export default __webpack_public_path__ + "static/media/Welaunch_Profile_Pic.30dbbb01.svg";